var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageDetails',{attrs:{"project-id":_vm.projectId,"config-id":_vm.configId,"name":_vm.module && _vm.module.name,"config":_vm.config,"data":_vm.data,"target-type":_vm.target,"is-loading":_vm.isLoading},on:{"save":_vm.onSave}})}
var staticRenderFns = []

export { render, staticRenderFns }